/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
import React from "react";
import styled from "styled-components";
import TextField from "@material-ui/core/TextField";

const CustomTextField = (props: any) => (
  <TextField {...props} variant="outlined" />
);

const StyledTextArea = styled(CustomTextField)`
  ${({ theme }) => `
  .MuiOutlinedInput-root {

    &:hover {
      &:not(.Mui-focused) .MuiOutlinedInput-notchedOutline {
        border-color: ${theme.palette.text.secondary};
      }
      .MuiInputLabel-outlined {
        color: ${theme.palette.primary.main};
      }
    }
    
    legend {
      width: 0px !important;
    }
  }

  .MuiOutlinedInput-notchedOutline {
    border-width: 1px;
    border-color: ${theme.palette.border.dark};
    border-radius: 3px;
  }

  .MuiOutlinedInput-input {
    font-weight: 400;
    padding: 14px 12px;
    color: ${theme.palette.text.primary};
  }

  .MuiInputLabel-outlined {
    transform: none;
    position: relative;
    margin-bottom: 8px;
    font-weight: 700;
    color: ${theme.palette.text.primary};
    z-index: unset;
    pointer-events: unset;

    &.Mui-disabled {
      color: ${theme.palette.text.disabled};
    }
  }

  .MuiFormHelperText-contained {
    margin: 3px 0 0;
  }

  .MuiOutlinedInput-root.Mui-disabled {
    color: ${theme.palette.text.disabled};

    &:hover {
      .MuiOutlinedInput-notchedOutline {
        border-color: ${theme.palette.text.disabled};
      }
    }

    .MuiOutlinedInput-input {
      color: ${theme.palette.text.disabled};
      background: ${theme.palette.action.disabledBackground};
      border-radius: ${theme.shape.borderRadius}px;
    }
    
    .MuiOutlinedInput-notchedOutline {
      border-color: ${theme.palette.text.disabled};
    }
  }
  `}
`;

export default StyledTextArea;
